import { motion } from "framer-motion";
import { LineReveal, FadeUp, EASE } from "@/components/site/Reveal";

const Bar = ({ width, delay, className, children }) => (
  <motion.div
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.2, delay, ease: EASE }}
    style={{ width, originX: 0 }}
    className={`h-full flex flex-col justify-end p-4 sm:p-6 ${className}`}
  >
    {children}
  </motion.div>
);

export const LeaseSplit = () => (
  <section data-testid="lease-split-section" className="relative bg-[var(--navy)] overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-24 lg:py-36 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <p className="eyebrow">Green Operational Leasing</p>
        <LineReveal onView lines={["Pay nothing", "upfront. Keep", "the difference."]} className="mt-5 font-display font-black uppercase leading-[0.88] text-5xl sm:text-6xl lg:text-7xl" />
        <FadeUp>
          <p className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed">
            Redirect your monthly power-bill savings — up to $6,000 for a large 100kW carwash — into around $2,000 per month for your solar solution. 100% tax deductible, with no messy accounting or depreciation schedules.
          </p>
        </FadeUp>
      </div>
      <div className="lg:col-span-7 flex flex-col justify-end">
        <FadeUp>
          <div className="flex justify-between font-mono text-xs tracking-[0.2em] uppercase text-slate-300 mb-3">
            <span>Monthly power savings</span><span>$6,000</span>
          </div>
          <div className="h-48 sm:h-56 flex rounded-2xl overflow-hidden bg-white/5" data-testid="lease-split-bar">
            <Bar width="33.4%" delay={0.1} className="bg-[var(--solar)]">
              <span className="font-display font-black text-3xl sm:text-5xl">$2,000</span>
              <span className="text-xs sm:text-sm text-white/90">Lease payment</span>
            </Bar>
            <Bar width="66.6%" delay={0.35} className="bg-[var(--sun)] text-[var(--ink)]">
              <span className="font-display font-black text-3xl sm:text-5xl">$4,000</span>
              <span className="text-xs sm:text-sm">Kept as pure bottom-line profit</span>
            </Bar>
          </div>
          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <div className="rounded-xl border border-white/10 p-6">
              <p className="font-display font-black text-5xl text-[var(--sun)]">$48,000</p>
              <p className="mt-1 text-slate-300">extra profit every year you don't throw away</p>
            </div>
            <div className="rounded-xl border border-white/10 p-6">
              <p className="font-display font-black text-5xl text-white">↑ Value</p>
              <p className="mt-1 text-slate-300">How much does that lift your carwash valuation?</p>
            </div>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
